// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__JHYYv","requiredAsterisk":"Info_requiredAsterisk__3FvBT"};